export const THIRD_DAY = 3;
